import React, {useState} from 'react'
import {TextareaAutosize} from "@mui/material";
import {observer} from "mobx-react";
import './modal.scss';
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const ReleaseNotesDialog = observer(() => {
    const {modalStore, generalStore, procedureStore} = useStores();

    const [releaseNotes, setReleaseNotes] = useState('');
    const {procedureVersion, procedureId} = modalStore.modalData;

    async function save() {
        generalStore.isLoaderOpen = true;
        try {
            const versionObj = {
                versionNumber: procedureVersion.Version,
                releaseNotes
            };
            await procedureStore.editReleaseNotes(procedureId, versionObj);
            await modalStore.modalData.onSaved();
            modalStore.modalData = {};
            modalStore.isReleaseNotesModalOpen = false;

        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('cannotEditReleaseNotes'));
        }

        generalStore.isLoaderOpen = false;
    }

    function onEnter() {
        setReleaseNotes(procedureVersion.ReleaseNotes);
    }


    function renderBody() {
        return (
            <TextareaAutosize
                className='release-notes-input'
                variant='outlined'
                onChange={(e) => setReleaseNotes(e.target.value)}
                minRows={10}
                value={releaseNotes}
            />
        );
    }

    return (

        <GeneralDialog
            openControl='isReleaseNotesModalOpen'
            className='blue-dialog edit-notes-dialog'
            onEnter={onEnter}
            title={`${generalStore.translate('changesInVersionSentence1_beforeVersion')} ${procedureVersion?.Version} ${generalStore.translate('changesInVersionSentence2_afterVersion')}`}
            body={renderBody()}
            isConfirmDisabled={false}
            onConfirm={save}
            confirmText={generalStore.translate('save')}
        />
    )
})

export default ReleaseNotesDialog;
